import { render, staticRenderFns } from "./Yonghuguanli.vue?vue&type=template&id=4d137d3b&scoped=true&"
import script from "./Yonghuguanli.vue?vue&type=script&lang=js&"
export * from "./Yonghuguanli.vue?vue&type=script&lang=js&"
import style0 from "./Yonghuguanli.vue?vue&type=style&index=0&id=4d137d3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d137d3b",
  null
  
)

export default component.exports